import type { SourceFile } from 'ts-morph'
import { ts } from 'ts-morph'

export function getScriptKind(filePath: string): ts.ScriptKind {
  if (filePath.endsWith('.tsx')) {
    return ts.ScriptKind.TSX
  }

  if (filePath.endsWith('.jsx')) {
    return ts.ScriptKind.JSX
  }

  return ts.ScriptKind.TS
}

/** `parseDiagnostics` is present on the compiler node but absent from its public type. */
export function hasParseDiagnostics(sourceFile: SourceFile): boolean {
  const diagnostics =
    (sourceFile.compilerNode as ts.SourceFile & { parseDiagnostics?: readonly ts.Diagnostic[] })
      .parseDiagnostics ?? []
  return diagnostics.length > 0
}
